import ClientSeriesTile from '../tiles/client-series';
import TileRow from '../tile-row';
import { Series } from 'types';

export default function SeriesComponent({
  series,
  rowTitle = 'Read them all',
}: {
  series: Series;
  rowTitle?: string;
}) {
  if (!series) return null;

  return (
    <TileRow title={rowTitle} tileStyle="content" hideScrollbar>
      {[<ClientSeriesTile key={series.id} series={series} />] as any}
    </TileRow>
  );
}
